import { Box, Typography, Paper } from '@mui/material'

export default function RewardProgramSummary({ rewardPrograms }) {
  return (
    <Box>
      {rewardPrograms.map((program, i) => (
        <Box key={i} border={1} borderColor="grey.300" borderRadius={2} mb={2}>
          <Typography variant="h5">{program.name}</Typography>
          <Paper variant="outlined" sx={{ p: 2, overflowX: 'auto' }}>
            <pre>{JSON.stringify(program, null, 2)}</pre>
          </Paper>
        </Box>
      ))}
    </Box>
  )
}
